import { render, staticRenderFns } from "./edit-independent-program.vue?vue&type=template&id=e5f82084&scoped=true&"
import script from "./edit-independent-program.ts?vue&type=script&lang=ts&"
export * from "./edit-independent-program.ts?vue&type=script&lang=ts&"
import style0 from "./edit-independent-program.scss?vue&type=style&index=0&id=e5f82084&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f82084",
  null
  
)

export default component.exports